var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgDiskIcon = function SvgDiskIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 23",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.312 16.31 1.057-2.618 2.618 1.057-1.057 2.618zm2.733-5.802 2.645-6.545 2.618 1.058-2.645 6.545zm-7.25 3.61a2.823 2.823 0 0 1-2.824-2.824 2.814 2.814 0 0 1 2.823-2.823 2.824 2.824 0 1 1 0 5.647zm0-14.118C5.556 0 .5 5.057.5 11.294c0 6.238 5.057 11.294 11.294 11.294a11.294 11.294 0 0 0 11.294-11.294C23.088 5.057 18.032 0 11.794 0z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDiskIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;